export const RESET_EDIT_MASTER_STORE = "RESET_EDIT_MASTER_STORE";
export const UPDATE_MASTER_TEMPLATE_INFO = "UPDATE_MASTER_TEMPLATE_INFO";
